import React, { useState, useEffect } from "react";
import Modal from "../modal/Modal";
import { useTranslation } from "react-i18next";

type Props = {
  visible: boolean;
  pages: any[];
  selectedPages: string[];
  position: any;
  onClose: () => void;
  onUpload: (pages: string[], originalPdf: any) => void;
  remaining: number;
};

const PageSelectionModal: React.FC<Props> = ({
  visible,
  pages,
  selectedPages,
  position,
  remaining,
  onClose,
  onUpload,
}) => {
  const { t } = useTranslation();
  const [localSelectedPages, setLocalSelectedPages] = useState<number[]>([]);
  const [remainingUploads, setRemainingUploads] = useState<number>(remaining);

  useEffect(() => {
    const initialSelectedPages = selectedPages
      .map((url) => pages.findIndex((page) => page.url === url))
      .filter((index) => index !== -1);
    setLocalSelectedPages(initialSelectedPages);
    setRemainingUploads(remaining - initialSelectedPages.length);
  }, [selectedPages, pages, remaining]);

  const handleTogglePage = (index: number) => {
    setLocalSelectedPages((prevSelected) => {
      const isSelected = prevSelected.includes(index);
      const updatedSelected = isSelected
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index];

      const updatedRemaining = isSelected
        ? remainingUploads + 1
        : remainingUploads - 1;

      setRemainingUploads(updatedRemaining);
      return updatedSelected;
    });
  };

  const handleUpload = () => {
    const selectedPageUrls = localSelectedPages.map(
      (index) => pages[index].url
    );
    const selectedPdfPages = localSelectedPages.map(
      (index) => pages[index].originalPdfPage
    );
    onUpload(selectedPageUrls, selectedPdfPages);
    onClose();
  };
  return (
    <Modal
      title={t("selectPages")}
      compact
      visible={visible}
      onClose={onClose}
    >
      <div className="page-selection-modal p-4 ">
        <div className="pdf-selection-modal">
          {" "}
          <div className="flex justify-between mb-4">
            <div>
              <p className="text-lg">
                {t("Position")}: {position.position}
              </p>
              <p className="text-sm text-gray-600">
                {t("widthInclTrim")}: {position.width} mm
              </p>
              <p className="text-sm text-gray-600">
                {t("heightInclTrim")}: {position.height} mm
              </p>
            </div>
          </div>
          <div className="border-b border-gray-300 mb-4"></div>
          <div className="flex flex-col space-y-4">
            <div className="mb-2 text-lg">
              <div className="mb-2 text-sm text-gray-600">
                Datei: {pages[0]?.fileName} {pages[0]?.fileSize}
              </div>
              <div className="mb-2 text-sm text-gray-600">
                {t("remaining")}: {remainingUploads}
              </div>
            </div>

            {pages.map((page, idx) => (
  <div
    key={idx}
    className={`flex items-center justify-between gap-6 mt-4 border border-gray-200 bg-white shadow-sm p-4 rounded-lg transition-all 
      ${
        remainingUploads <= 0 && !localSelectedPages.includes(idx)
          ? "opacity-40 cursor-not-allowed"
          : "hover:shadow-md"
      }`}
  >
    <div className="flex items-center gap-3">
      <input
        type="checkbox"
        id={`checkbox-${idx}`}
        checked={localSelectedPages.includes(idx)}
        onChange={() => handleTogglePage(idx)}
        className="h-5 w-5 rounded border-gray-400 text-black focus:ring-black"
        disabled={remainingUploads <= 0 && !localSelectedPages.includes(idx)}
      />

      <label htmlFor={`checkbox-${idx}`} className="flex flex-col">
        <p className="text-base font-medium text-gray-900">{t("page")} {idx + 1}</p>
        <p className="text-sm text-gray-500">{page.dimensions}</p>
      </label>
    </div>

    <div className="text-sm  text-gray-700">
      {page.fileName}
    </div>
  </div>
))}

          </div>
        </div>
        <div className="flex justify-end gap-25 mt-20">
  <button
    onClick={onClose}
    className="px-4 py-2 bg-black text-white rounded-full w-48"
  >
    {t("Abbrechen")}
  </button>

  <button
    onClick={handleUpload}
    disabled={localSelectedPages.length === 0}
    className={`
      px-4 py-2 rounded-full w-48 border-2 transition-all

      ${
        localSelectedPages.length === 0
          ? "bg-[#80B3E6] text-white border-[#80B3E6] cursor-not-allowed"
          : "bg-[#0066CC] text-white hover:bg-white hover:text-[#0066CC] hover:border-[#0066CC] border-[#0066CC]"
      }
    `}
  >
    {t("Fertig")}
  </button>
</div>

      </div>
    </Modal>
  );
};

export default PageSelectionModal;
